import { Box, Chip, SxProps, Typography } from '@mui/material'
import React from 'react'

type Props = {
    heading: string;
    sx?: SxProps;
    data: { key: string, tag_name: string, onClick?: React.MouseEventHandler<HTMLDivElement> }[];
}

const TagCustom: React.FC<Props> = ({ heading, data, sx }: Props) => {
    return (
        <Box sx={sx} className='w-full mt-4 flex flex-col'>
            <span>
                <Typography sx={{
                    color: "#000",
                }} variant='h6'>{heading}</Typography>
            </span>
            <span className='flex flex-wrap gap-2 py-2'>
                {data?.length > 0 ? data?.map((list) => {
                    return (
                        <Chip
                            key={list?.key}
                            sx={{
                                color: "#000",
                                // backgroundColor: (theme) => mode === 'dark' ? theme.palette.bg_color.black : theme.palette.bg_color.white
                            }}
                            onClick={list.onClick}
                            label={list?.tag_name || ""}
                            variant="outlined"
                        />
                    )
                }) : <Typography sx={{
                    color: "#000",
                }}>ไม่มีข้อมูล</Typography>}
            </span>
        </Box>
    )
}

export default TagCustom